<template>
  <div id="ch_popup_cinema" class="modal-block fade" role="dialog">
    <div class="modal-dialog message-modal" role="document">
      <div class="modal-content" v-if="d_cinemas">
        <div class="modal-content-block">
          <div class="candypop">
            <div class="candypop-cinema-title">
              <span>Disponible en:</span>
            </div>
            <div class="candypop-cinema-select">
              <select ref="cines" onchange="ChangeCinemaSelect(this.value)">
                <option value="0"></option>
                <template v-for="(cinema,index) in d_cinemas">
                  <option :value="cinema.CinemaId">{{cinema.strName}}</option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

require("./../assets/jquery.bpopup.min.js");

export default {
  name: "popupcinemashome",
  data: function() {
    return {
        d_cinemas: null
    };
  },
  computed: {
  },
  updated() {
    $(this.$refs.cines).SumoSelect({nativeOnDevice: [], placeholder: 'Seleccione un Complejo'});
    $(this.$refs.cines).SumoSelect().sumo.reload();
  },
  methods: {
    //Seteo el object con los atributos a mostrar.
    m_open: function(cinemas) {
        this.d_cinemas = cinemas;
        var bPopup = $(this.$el).bPopup({
            modalClose: false
        });
    },
    onChange: function(value){
      if (this.$root.d_App == "True")
       window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?App=1&FeatureId=0&CinemaId=" + value;
      else
       window.location = this.$root.d_get_url_merch + "nsMerchCandys.aspx?FeatureId=0&CinemaId=" + value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PopupCinemas.vue